import { render, staticRenderFns } from "./MobileTopNavbar.vue?vue&type=template&id=bdcafbd6&scoped=true"
import script from "./MobileTopNavbar.vue?vue&type=script&lang=js"
export * from "./MobileTopNavbar.vue?vue&type=script&lang=js"
import style0 from "./MobileTopNavbar.vue?vue&type=style&index=0&id=bdcafbd6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdcafbd6",
  null
  
)

export default component.exports